import axios from 'axios';

import router from '@/router';
import auth from '@/utils/auth';

import {
  DELETE_SYNDICATE,
  DELETE_SYNDICATE_ERROR,
  DELETE_SYNDICATE_SUCCESS,

  GET_SYNDICATE,
  GET_SYNDICATE_ERROR,
  GET_SYNDICATE_SUCCESS,

  GET_SYNDICATES,
  GET_SYNDICATES_ERROR,
  GET_SYNDICATES_SUCCESS,

  SAVE_SYNDICATE,
  SAVE_SYNDICATE_ERROR,
  SAVE_SYNDICATE_SUCCESS,

  SAVE_SYNDICATE_LINKS,
  SAVE_SYNDICATE_LINKS_SUCCESS,
  SAVE_SYNDICATE_LINKS_ERROR,

  GET_ADMINISTRATORS,
  GET_ADMINISTRATORS_ERROR,
  GET_ADMINISTRATORS_SUCCESS,

  SAVE_ADMINISTRATORS,
  SAVE_ADMINISTRATORS_ERROR,
  SAVE_ADMINISTRATORS_SUCCESS,

  SAVE_COMMON_CHARGE,
  SAVE_COMMON_CHARGE_ERROR,
  SAVE_COMMON_CHARGE_SUCCESS,

  SAVE_DOCUMENT,
  SAVE_DOCUMENT_ERROR,
  SAVE_DOCUMENT_SUCCESS,

} from './constants';

export default {
  async [DELETE_SYNDICATE]({ commit }, data) {
    try {
      commit(DELETE_SYNDICATE);
      const response = await axios({
        url: `${process.env.API_URL}/api/syndicates/${data.syndicateID}/delete-id`,
        method: 'POST',
        headers: auth.getAuthHeader(),
        data: {
          password: data.passwordConfirmation,
        },
      });
      await axios({
        url: `${process.env.API_URL}/api/syndicates/${data.syndicateID}`,
        method: 'DELETE',
        headers: auth.getAuthHeader(),
        params: {
          deleteID: response.data.deleteID,
        },
      });
      commit(DELETE_SYNDICATE_SUCCESS);
      router.push({ name: 'Syndicate Listing' });
    } catch (err) {
      commit(DELETE_SYNDICATE_ERROR, err);
    }
  },

  async [GET_SYNDICATE]({ commit }, data) {
    try {
      commit(GET_SYNDICATE);
      const response = await axios({
        url: `${process.env.API_URL}/api/syndicates/${data.syndicateID}`,
        method: 'GET',
        headers: auth.getAuthHeader(),
        params: data.loaded && { loaded: '1' },

      });
      commit(GET_SYNDICATE_SUCCESS, response.data);
    } catch (err) {
      commit(GET_SYNDICATE_ERROR, err);
    }
  },

  async [GET_SYNDICATES]({ commit }, args) {
    try {
      commit(GET_SYNDICATES);
      const response = await axios({
        url: `${process.env.API_URL}/api/syndicates`,
        method: 'GET',
        headers: auth.getAuthHeader(),
        params: {
          filters: args.filters || null,
        },
      });
      commit(GET_SYNDICATES_SUCCESS, response.data);
    } catch (err) {
      commit(GET_SYNDICATES_ERROR, err);
    }
  },

  async [SAVE_SYNDICATE]({ commit }, data) {
    try {
      commit(SAVE_SYNDICATE);
      let url = `${process.env.API_URL}/api/syndicates`;
      let method = 'POST';
      if (data.syndicateID) {
        url = `${url}/${data.syndicateID}`;
        method = 'PUT';
      }
      const response = await axios({
        url,
        method,
        headers: auth.getAuthHeader(),
        data,
      });
      commit(SAVE_SYNDICATE_SUCCESS, response.data);
      if (method === 'POST' && response.data.syndicateID) {
        router.push({ name: 'Syndicate Dashboard', params: { syndicateID: response.data.syndicateID } });
      }
    } catch (err) {
      commit(SAVE_SYNDICATE_ERROR, err);
    }
  },
  async [SAVE_SYNDICATE_LINKS]({ commit }, data) {
    try {
      commit(SAVE_SYNDICATE_LINKS);
      let url = `${process.env.API_URL}/api/syndicates`;
      let method = 'POST';
      if (data.syndicateID) {
        url = `${url}/${data.syndicateID}/syndicate-links`;
        method = 'PUT';
      }
      const response = await axios({
        url,
        method,
        headers: auth.getAuthHeader(),
        data,
      });
      commit(SAVE_SYNDICATE_LINKS_SUCCESS, response.data);
      if (method === 'POST' && response.data.syndicateID) {
        router.push({ name: 'Syndicate Dashboard', params: { syndicateID: response.data.syndicateID } });
      }
    } catch (err) {
      commit(SAVE_SYNDICATE_LINKS_ERROR, err);
    }
  },

  async [GET_ADMINISTRATORS]({ commit }, syndicateID) {
    try {
      commit(GET_ADMINISTRATORS);
      const response = await axios({
        url: `${process.env.API_URL}/api/syndicates/${syndicateID}/administrators`,
        method: 'GET',
        headers: auth.getAuthHeader(),
      });
      commit(GET_ADMINISTRATORS_SUCCESS, response.data);
    } catch (err) {
      commit(GET_ADMINISTRATORS_ERROR, err);
    }
  },

  async [SAVE_ADMINISTRATORS]({ commit }, { syndicateID, syndicateAdministrators }) {
    try {
      commit(SAVE_ADMINISTRATORS);
      const response = await axios({
        url: `${process.env.API_URL}/api/syndicates/${syndicateID}/administrators`,
        method: 'PUT',
        headers: auth.getAuthHeader(),
        data: syndicateAdministrators,
      });
      commit(SAVE_ADMINISTRATORS_SUCCESS, response.data);
    } catch (err) {
      commit(SAVE_ADMINISTRATORS_ERROR, err);
    }
  },

  async [SAVE_COMMON_CHARGE]({ commit }, { syndicateID, commonCharge }) {
    try {
      commit(SAVE_COMMON_CHARGE);
      const response = await axios({
        url: `${process.env.API_URL}/api/syndicates/${syndicateID}/common-charge`,
        method: 'PUT',
        headers: auth.getAuthHeader(),
        data: {
          commonCharge,
        },
      });
      commit(SAVE_COMMON_CHARGE_SUCCESS, response.data);
    } catch (err) {
      commit(SAVE_COMMON_CHARGE_ERROR, err);
    }
  },

  async [SAVE_DOCUMENT]({ commit }, data) {
    try {
      commit(SAVE_DOCUMENT);
      const response = await axios({
        url: `${process.env.API_URL}/api/syndicates/${data.syndicateID}/document-link`,
        method: 'PUT',
        headers: auth.getAuthHeader(),
        data: data.data,
      });
      commit(SAVE_DOCUMENT_SUCCESS, response.data);
    } catch (err) {
      commit(SAVE_DOCUMENT_ERROR, err);
    }
  },
};



// WEBPACK FOOTER //
// ./src/components/Syndicates/actions.js